<template>
  <div>
    <div class="header" style="background: black;">
      <img src="../assets/nueva.jpg" alt class="img-fluid" style="opacity: 0.8;" />
      <div class="title-wrapper">
        <!-- <h3 style="margin-bottom: 0; padding-left: 5px;">Volkswagen Recall</h3> -->
        <h1>Volkswagen Recall</h1>
      </div>
    </div>
    <div id="atencion" v-if="0">
      <h1>Llamado a la seguridad</h1>
      <p>Si tenés un Gol Power, Suran o Fox del 2006 a 2010, chequeá si es parte de la campaña de recall de airbags Takata***.</p>
      <p>Realizá sin costo la verificación en nuestros concesionarios oficiales y te bonificamos un cambio de aceite y filtro.</p>
      <p>Nuestra prioridad siempre va a ser cuidarte</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["titulo"]
};
</script>

<style lang="scss" scoped>
  #atencion {
    padding: 2em 0 3.4em;
    text-align: center;
    color: white;
    background: radial-gradient(circle at 0% 0%, rgb(0, 67, 122) 0%, rgb(0, 30, 80) 100%);
    margin-bottom: 4em;
    h1 {
      margin-bottom: 0.5em;
    }
    p {
      font-weight: 300;
      font-size: 1.2em;
    }
  }
.header {
  position: relative;
  color: #ffffff;
  display: flex;
  align-items: center;
  overflow: hidden;
  & > img {
    width: 100%;
    height: 41em;
    object-fit: cover;
    @media (max-width: 669px) {
      // object-fit: cover;
      // width: 100%;
      // object-position: 90% 100%;
      height: 36.5em;
    }
  }

  h1 {
    margin-bottom: 1em;
    font-weight: 400;
  }

  h2 {
    font-weight: 300;
  }

  h3 {
    font-size: 2.8em;
    font-weight: bold;
    letter-spacing: 0.02em;
    @media (max-width: 767px) {
      font-size: 2em;
    }
  }

  .title-wrapper {
    position: absolute;
    top: 15%;
    left: 6.5%;
    width: 100%;
    padding-top: 3em;
    padding-left: 3rem;
    @media (max-width: 669px) {
      padding-top: 0;
      padding-left: 0;
      top: auto;
      bottom: 4%;
    }

    h1 {
      font-size: 5.2em;
      letter-spacing: 0.019em;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      font-weight: 400;
      color: #ffffff;
      padding: 10px 5px;

      @media (max-width: 767px) {
        font-size: 3.9em;
        line-height: 1.2em;
        padding-top: 0;
        margin-top: 0;
      }
    }
    h2 {
      @media (max-width: 767px) {
        font-size: 2em;
        margin-bottom: 1em;
      }
    }
  }
}
</style>
